:host {
  display: block;
  width: 100%;
}

.ai-chat-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 7px 22px rgba(19, 19, 19, 0.08);

  .loading-state {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    padding: 50px;
    position: relative;
    box-sizing: border-box;
  }

  .ai-chat-container {
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    background: var(--ux-color-background-default);
    border-radius: var(--ux-border-radius-large);
    margin: 0 auto;
    overflow: hidden;
    font-family: var(--ux-font, "Frutiger-Web", sans-serif);

    .chat-main-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 100%;
      position: relative;
    }

  }

  .ai-chat-header {
    position: relative;
    width: 100%;
  }

  .ai-chat-feedback-button {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .empty-state {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    color: var(--ux-color-text-secondary);

    ux-icon {
      color: var(--ux-color-text-secondary);
    }
  }

  .error-state {
    color: var(--ux-color-error);

    ux-icon {
      color: var(--ux-color-error);
    }
  }

  .error-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  .disabled-chat {
    pointer-events: none;
    opacity: 0.7;
  }

  .disclaimer-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
  }
}